import { getImages, modificarImagenes, submitImagenes } from "../../services/PanelService.js";
import { CircleLoader } from "react-spinners";
import { Button, Checkbox, FormControlLabel } from "@mui/material";
import { RiDeleteBinLine } from 'react-icons/ri';
import { baseURL } from "../../extras/Axios.js";
import { useContext, useEffect, useRef, useState } from "react";
import { AdminContext } from "../../context/AdminContext";
import Fab from "@mui/material/Fab";
import { StyledFloatingButton } from './PanelComponents.jsx';
import { SNACKBAR_SEVERITY } from '../../constants/index.js';

function BannerImagesTab() {

    const { handleClickSnackbar } = useContext(AdminContext);

    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(false);
    const fileButtonRef = useRef();

    async function handleImageSelection(event) {
        const formData = new FormData();
        [...event.target.files].forEach(file => formData.append("images", file));
        const result = await submitImagenes(formData)
        if (result) {
            handleClickSnackbar("Agregado con exito", SNACKBAR_SEVERITY.success);
            await getUsedImages();
        }
    }

    async function getUsedImages() {
        setLoading(true);
        const result = await getImages();
        if (result && result.length > 0) setImages(result);
        setLoading(false);
    }

    useEffect(() => {
        getUsedImages();
    }, []);

    const changeImageStatus = (imageName) => {
        setImages(prev => prev.map(image => {
            if (image.name === imageName) {
                image.used = !image.used;
            }
            return image;
        }))
    }

    const deleteImage = (imageName) => {
        setImages(prev => prev.filter(image => image.name !== imageName));
    };

    const guardarCambios = async () => {
        await modificarImagenes(images);
        await getUsedImages();
    }

    return (
        <div style={{ display: "flex", flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <CircleLoader loading={loading} cssOverride={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />
            <div style={{ display: 'flex', flexDirection: "row", flexWrap: "wrap", justifyContent: 'center', alignItems: 'center' }}>
                {
                    images.map(image =>
                        <div key={image.name} style={{ borderWidth: 1, padding: 20, marginLeft: 25, borderColor: "black", flex: 1, borderStyle: "solid", display: "flex", flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                            <img src={`${baseURL}banner/${image.name}`} />
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', marginLeft: 5 }}>
                                <RiDeleteBinLine size={35} onClick={() => deleteImage(image.name)} />
                                <FormControlLabel control={<Checkbox label="Usar" checked={image.used} onChange={() => changeImageStatus(image.name)} />} label="Usar" />

                            </div>
                        </div>)
                }
            </div>
            <Button onClick={guardarCambios} style={{ margin: 20 }} color='primary' variant='contained'>Guardar Cambios</Button>
            <input accept='.png' onChange={handleImageSelection} style={{ opacity: 0 }} ref={fileButtonRef} type="file" multiple />
            <StyledFloatingButton>
                <Fab color="secondary" aria-label="add" onClick={() => fileButtonRef.current.click()}>
                    +
                </Fab>
            </StyledFloatingButton>
        </div>
    )
}

export default BannerImagesTab